import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// Best-effort "typing" heartbeat for peer chats: while the user types in the
// compose box we POST to the typing endpoint at most once per PING_MS. The
// server-side cache flag expires on its own (~8s), so the peer's 5s poll
// shows the indicator while typing and drops it shortly after it stops.
const PING_MS = 2500

export default class extends Controller {
    static values = { url: String }

    ping() {
        let now = Date.now()
        if (this._lastPing && now - this._lastPing < PING_MS) return
        this._lastPing = now
        fetch(this.urlValue, {
            method: "POST",
            headers: { "Accept": "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin"
        }).catch(() => {})
    }

}
